import { render, staticRenderFns } from "./QuoteEditor.vue?vue&type=template&id=035d3375&scoped=true&"
import script from "./QuoteEditor.vue?vue&type=script&lang=ts&"
export * from "./QuoteEditor.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteEditor.vue?vue&type=style&index=0&id=035d3375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d3375",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VScrollXReverseTransition } from 'vuetify/lib/components/transitions';
import { VScrollXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VScrollXReverseTransition,VScrollXTransition})
